import { RELATIONSHIPS } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { getFormDataFieldValue } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  ADD_RELATIONSHIPS,
  RELATIONSHIP_FIELD_BY_TYPE,
  RELATIONSHIP_TYPE,
  CONFIGURATION_ITEM_WITH_UA,
  CONFIGURATION_ITEM_UA_TYPE,
  CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE,
  CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE,
  VISIBLE_RELATIONSHIP_TYPES,
  RELATIONSHIP_TYPE_API_PARAMETER,
  CONFIGURATION_ITEM_UA_TYPE_API_PARAMETER,
  RELATIONSHIP_HOW_RELATED,
  RT_CI_UNAVAILABILITY,
  CONFIGURATION_ITEM_ACTUAL_START_DATE,
  CONFIGURATION_ITEM_ACTUAL_END_DATE,
  CONFIGURATION_ITEM, // importing here for all relationship values for ci defect
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import {
  RT_CONFIGURATION_ITEM,
  configItemWithUAYes,
  configItemWithUANo,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const relationshipParameterMap = [
  { param: RELATIONSHIP_TYPE_API_PARAMETER, field: RELATIONSHIP_TYPE },
  { param: 'ua_scheduled_start_date', field: CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE },
  { param: 'ua_scheduled_end_date', field: CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE },
  { param: CONFIGURATION_ITEM_UA_TYPE_API_PARAMETER, field: CONFIGURATION_ITEM_UA_TYPE },
  { param: 'type', field: RELATIONSHIP_HOW_RELATED },
];

const ciUnavailabilityParameterMap = [
  { param: 'name', field: 'name' },
  { param: 'reference_id', field: 'reference_id' },
  { param: 'status', field: 'status' },
  { param: 'actual_start_date', field: CONFIGURATION_ITEM_ACTUAL_START_DATE },
  { param: 'actual_end_date', field: CONFIGURATION_ITEM_ACTUAL_END_DATE },
  { param: 'ua_scheduled_start_date', field: 'ua_scheduled_start_date' },
  { param: 'ua_scheduled_end_date', field: 'ua_scheduled_end_date' },
  { param: 'ua_type', field: 'ua_type' },
  { param: 'type', field: 'type' },
  { param: 'reference_type', field: 'reference_type' },
  { param: 'id', field: 'id' },
];

const ViewCompletionReviewCIDetails = ['actual_start_date', 'actual_end_date', 'status', 'name', 'referenceId', 'uaScheduledStartDate', 'uaScheduledEndDate', 'uaType', 'type', 'referenceType', 'id'];
const relationshipIsWithUa = (sectionData) => {

  const relationshipType = sectionData.dataByFieldId[RELATIONSHIP_TYPE].value;
  // RT_CI_UNAVAILABILITY type relationships always have UA form data
  if (relationshipType === RT_CI_UNAVAILABILITY) {
    return true;
  }
  const withUaField = sectionData.dataByFieldId[CONFIGURATION_ITEM_WITH_UA];
  const withUaValue = withUaField ? withUaField.value : null;
  return withUaValue && withUaValue[0] === configItemWithUAYes;
};

const isRelationshipTypeRecognised = (relationshipType) => (VISIBLE_RELATIONSHIP_TYPES.includes(relationshipType));
// return true;
// };

const getUAFormParameters = (sectionData) => {
  const isWithUa = relationshipIsWithUa(sectionData);
  if (!isWithUa) {
    return {};
  }
  const uaType = sectionData.dataByFieldId[CONFIGURATION_ITEM_UA_TYPE].value;
  const uaScheduledStartDate = sectionData.dataByFieldId[CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE].value;
  const uaScheduledEndDate = sectionData.dataByFieldId[CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE].value;
  return ({
    uaType,
    uaScheduledStartDate,
    uaScheduledEndDate,
  });
};

const getRelationshipParametersForSectionId = ({
  formData,
  sectionId,
}) => {
  const relationshipsModal = getFormDataFieldValue({
    formData,
    sectionId: RELATIONSHIPS,
    fieldId: ADD_RELATIONSHIPS,
  });
  const sectionData = relationshipsModal.dataByFormSectionId[sectionId];
  const referenceType = sectionData.dataByFieldId[RELATIONSHIP_TYPE].value;
  const { relationshipId } = sectionData;

  const relationshipField = RELATIONSHIP_FIELD_BY_TYPE[referenceType];
  const relationshipValue = sectionData.dataByFieldId[relationshipField].value;
  const howRelatedField = sectionData.dataByFieldId[RELATIONSHIP_HOW_RELATED];
  const howRelatedValue = howRelatedField ? howRelatedField.value : null;

  // for config items we also add in the UA form fields
  const hasUaFields = [RT_CONFIGURATION_ITEM, RT_CI_UNAVAILABILITY].includes(referenceType);
  const uaFormFields = hasUaFields ? getUAFormParameters(sectionData) : {};
  return ({
    id: relationshipId,
    // the field that we call howRelated to avoid confusion, is actually `type` in the api
    type: howRelatedValue,
    ...relationshipValue,
    ...uaFormFields,
  });
};

const getRelationshipSectionValuesFromApiRelationship = (apiRelationship) => {
  const sectionValues = {};
  // fill in the parameters from the parameter map
  relationshipParameterMap.forEach(({
    field,
    param,
  }) => {
    sectionValues[field] = apiRelationship[param] || null;
  });
  // the value for CONFIGURATION_ITEM_WITH_UA is not on the server
  // it is infered from a CONFIGURATION_ITEM_UA_TYPE having a value
  const uaType = apiRelationship[CONFIGURATION_ITEM_UA_TYPE_API_PARAMETER];
  sectionValues[CONFIGURATION_ITEM_WITH_UA] = uaType ? configItemWithUAYes : configItemWithUANo;

  // fill in a relationship field dependend on the type of the relationship.
  // E.G relationships of type RT_INCIDENT should have a value for INCIDENT_REFERENCE
  // which is a relationship object.
  const relationshipType = apiRelationship[RELATIONSHIP_TYPE_API_PARAMETER];
  const relationshipField = CONFIGURATION_ITEM; // assigning here for ci defect.
  // const relationshipField = RELATIONSHIP_FIELD_BY_TYPE[relationshipType];
  // const relationshipField = 'configuration_item';

  if (relationshipField) {
    // Create a relationship object which will be the value for
    // the key relationshipField
    const relationship = {
      name: apiRelationship.name,
      referenceId: apiRelationship.reference_id,
      referenceType: relationshipType,
      status: apiRelationship.status,
    };
    sectionValues[relationshipField] = relationship;
  }
  return sectionValues;
};

const getCiUnavailabilitySectionValuesFromApiRelationship = (apiRelationship) => {
  const sectionValues = {};
  // fill in the parameters from the parameter map
  ciUnavailabilityParameterMap.forEach(({
    field,
    param,
  }) => {
    sectionValues[field] = apiRelationship[param] || null;
  });
  return sectionValues;
};

const getUnsavedRelationships = (formData) => {
  const unsavedRelationshipsFromForm = formData.unsavedRelationships || [];
  const unsavedRelationships = [];
  unsavedRelationshipsFromForm.forEach(({ sectionId, relationshipId, toDelete }) => {
    // if the relationship is for deletion, add the relationshipId to the array
    if (toDelete) {
      unsavedRelationships.push({
        relationshipId,
        toDelete,
      });
      return;
    }
    // this is a relationship to update, add the sectionId and the relationship parameters to the array.
    const relationship = getRelationshipParametersForSectionId({
      formData,
      sectionId,
    });
    if (relationship) {
      // add the sectionId and relationship as an entry in the unsaved relationships array
      unsavedRelationships.push({
        sectionId,
        relationship,
        toDelete,
      });
    }
  });
  return unsavedRelationships;
};

const getUnsavedRelationshipsCompletion = (formData) => {
  const unsavedRelationshipsFromForm = formData.dataByFieldId.ci_unavailability.value || [];
  const unsavedRelationships = [];
  const GetunsavedRelationships = unsavedRelationshipsFromForm.dataByFormSectionId;
  const unsavedRelationshipsArray = Object.keys(GetunsavedRelationships).forEach((items) => {
    const unsavedRelationshipsArrayElement = Object.keys(GetunsavedRelationships[items].dataByFieldId).map((item) => GetunsavedRelationships[items].dataByFieldId[item].value);
    unsavedRelationships.push(unsavedRelationshipsArrayElement);
    return unsavedRelationshipsArrayElement;
  });
  console.log(unsavedRelationshipsArray);
  const FinalUnsavedRelationship = unsavedRelationships.map((item) => {
    const results = Object.assign(...ViewCompletionReviewCIDetails.map((k, i) => ({ [k]: item[i] })));
    ['name', 'referenceId', 'referenceType', 'status', 'type'].forEach((e) => delete results[e]);
    return { relationship: results };
  });
  return FinalUnsavedRelationship;
};

export {
  getUnsavedRelationships,
  relationshipIsWithUa,
  isRelationshipTypeRecognised,
  getRelationshipSectionValuesFromApiRelationship,
  getCiUnavailabilitySectionValuesFromApiRelationship,
  getUnsavedRelationshipsCompletion,
};
